export type ColoursOption = {
  name: string;
  value: string;
  hexCode: string;
};

export const colourOptions: ColoursOption[] = [
  {
    name: 'topics:colour:options:shades:cyanBlue',
    value: 'cyan blue',
    hexCode: '#5BD7D7',
  },
  {
    name: 'topics:colour:options:shades:royalBlue',
    value: 'royal blue',
    hexCode: '#4573F5',
  },
  {
    name: 'topics:colour:options:shades:darkBlue',
    value: 'dark blue',
    hexCode: '#4A85FF',
  },
  {
    name: 'topics:colour:options:shades:brightBlue',
    value: 'bright blue',
    hexCode: '#52AEEE',
  },
  {
    name: 'topics:colour:options:shades:aquamarineBlue',
    value: 'aquamarine blue',
    hexCode: '#63DFFF',
  },
  {
    name: 'topics:colour:options:shades:brightGreen',
    value: 'bright green',
    hexCode: '#51CF95',
  },
  {
    name: 'topics:colour:options:shades:green',
    value: 'green',
    hexCode: '#50D17E',
  },
  {
    name: 'topics:colour:options:shades:brightYellow',
    value: 'bright yellow',
    hexCode: '#F1D40E',
  },
  {
    name: 'topics:colour:options:shades:lemonYellow',
    value: 'lemon yellow',
    hexCode: '#D9E355',
  },
  {
    name: 'topics:colour:options:shades:darkYellow',
    value: 'dark yellow',
    hexCode: '#EBBD40',
  },
  {
    name: 'topics:colour:options:shades:yellow',
    value: 'yellow',
    hexCode: '#D9BB34',
  },
  {
    name: 'topics:colour:options:shades:orange',
    value: 'orange',
    hexCode: '#E98F05',
  },
  {
    name: 'topics:colour:options:shades:fluorescentYellow',
    value: 'fluorescent yellow',
    hexCode: '#CFF160',
  },
  {
    name: 'topics:colour:options:shades:brightViolet',
    value: 'bright violet',
    hexCode: '#7737B9',
  },
  {
    name: 'topics:colour:options:shades:purple',
    value: 'purple',
    hexCode: '#5051F1',
  },
  {
    name: 'topics:colour:options:shades:darkViolet',
    value: 'dark violet',
    hexCode: '#70329F',
  },
  {
    name: 'topics:colour:options:shades:darkRed',
    value: 'dark red',
    hexCode: '#BB3D86',
  },
  {
    name: 'topics:colour:options:shades:fluorescentPink',
    value: 'fluorescent pink',
    hexCode: '#F473FF',
  },
  {
    name: 'topics:colour:options:shades:brightPink',
    value: 'bright pink',
    hexCode: '#F055A9',
  },
  {
    name: 'topics:colour:options:shades:softPink',
    value: 'soft pink',
    hexCode: '#EB667C',
  },
];
